import { Injectable } from '@angular/core'
import { CompanyDetailsService } from '../@services/company-details.service'
import { companyIdsToShowRefreshEasyWdmsVisits, customOfficeWisePreInvitePassCategories, FeedbackAndComplaintsUserFlowCustomizations, genericDomains, JLL_UK_offices, OfficeIdsForAddingVisitorDesignationInMAPreInvitePass } from './commonData'
import * as moment from 'moment-timezone'
import { Constants } from './constants'
import { ApiService } from '../@services/api.service'
import { Validation } from './validation'
import { CookieService } from 'ngx-cookie-service';



@Injectable({
    providedIn: 'root'
})
  export class commonFunctions {
    constructor(
      private companyService:CompanyDetailsService,
      private api : ApiService,
      private validation: Validation,
      private cookieService: CookieService
    ) {

    }
    beautyEncode(string) {
      if (string != undefined && string != null && string != '') {
        string = string.replace(/ /g, '-')
        string = string.replace(/,|&/g, '')
        string = string.replace(/\//, '')
        return string
      }
    }
    getPolicy(companyId){
        if(companyId == '6305c0f52319512dede1f3d5'){
            return `<ol><li>Visitors are allowed only to office area.</li><li>Access to plant area only with prior approval.</li><li>You are in a flammable zone. Lighter, Matchbox or any inflammable items are strictly prohibited.</li><li>Mobile phone is prohibited.</li><li>Photography is&nbsp;prohibited.</li><li>No smoking Area.</li><li>No Chewing of tobacco &amp; chewing gums.</li><li>No entry if you have communicable disease like Typhoid, Cholera, fever etc.</li><li>Visitors are kindly requested to complete the Visitors Health questionnaire.</li></ol>`
        }else{
            return '<ol><li>Please make sure that all information provided is correct.</li><li>Kindly follow covid appropriate behaviour.</li><li>Maintain social distancing and always wear a mask.</li></ol>'
        }
    }
    
    capitalizeFirstLetter(name){
    if(name && name.length>0){
        var nameArray = [];
        nameArray = name.split(' ');
        for(var i=0;i<nameArray.length;i++){
            nameArray[i] = nameArray[i].substr(0,1).toUpperCase() + nameArray[i].substr(1);
        }
        return nameArray.join(" ");
    }
     }
    getCategory(i){
      if(i == "1"){
        return "I Work Here"
      }else if(i == "2"){
        return "Meeting Appointment"
      }else if(i == "3"){
        return "Delivery"
      }else if(i == "4"){
        return "Service"
      }else if(i == "5"){
        return "Other"
      }else if(i == "6"){
        return "Company"
      }else if(i == "7"){
        return "VIP"
      }else if(i == "8"){
        return "Access Pass"
      }
    }
    getCategoryPassConfiguration(i,passConfiguration){
      if(i==8){
        return "Access"
      }else{
        let category = passConfiguration.find((ele)=> JSON.stringify(ele.code) == i)
        if(category){
          return category.displayName
        }
      }
   
    }
    getPassConfiguration(companyDetails: any, officeDetails: any = null){
      const officePassConfiguration = officeDetails?.passConfiguration;
      if(officePassConfiguration && Object.keys(officePassConfiguration).length){
        return {
          ...(companyDetails?.passConfiguration || {}),
          ...officePassConfiguration
        };
      }
      return companyDetails?.passConfiguration || null;
    }
    getPassConfigurationForOfficeId(companyDetails: any, offices: any[], officeId: string){
      const officeDetails = offices?.find((office) => office?.name?.toLowerCase() != 'all' && (office?._id == officeId || office?.id == officeId));
      return this.getPassConfiguration(companyDetails, officeDetails);
    }
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

    // todo : restrictions for sub menus for admins
    getMeetingRoomSubMenues(){
      return [
        {
          name:'Analytics',
          id:'analytics',
          url:'admin-dash/analytics',
          hasPermission:false
        },
        {
          name:'Qr Codes',
          id:'qr_codes',
          url:'admin-dash/analytics',
          hasPermission:false
        }
      ]
    }

    getOfficeList(offices, permissionDetails){
      
      let officeList = [];
      if(!permissionDetails || !permissionDetails.currentPermission['officeIds']){
        return officeList;
      }
      if(offices && offices.length>0){
        offices.forEach(element => {
          if(element.isActive){
            if(permissionDetails.roles && permissionDetails.roles.indexOf('Super Admin')>=0){
              officeList.push(element)
            }
            else if(permissionDetails.currentPermission['officeIds'].indexOf(element._id)>=0){
              officeList.push(element)
            }
            // element.productList  = this.getProductList(element)
          }
          
        });
      }
      return officeList
    }
    getImagekitUrl(img) {
      var str = ''
      if (img) str = img.replace('http://res.cloudinary.com/qdesqtest', 'https://qdesq.imagekit.io')
      return str
    }

    isDomainAllowed(email, officeId = null, checkAllOffices = false, company = null): boolean{
      if(!email){
        return;
      }

      let domain = email.split('@')[1]
      let companyDetails = this.companyService.companyDetails;
      
      if(!companyDetails){
        companyDetails = company;
      }
      if(!companyDetails){
        return false;
      }

      if(companyDetails && companyDetails.type && companyDetails.type.toLowerCase().includes('coworking')){
        return true
      }

      console.log('companyDetails====',companyDetails);
      
      if(companyDetails.id == '63eb3b41e0058b20d1f25a0e' || companyDetails.id == '63525948abaed853fca3771a'){
        if(genericDomains.indexOf(domain)>=0){
          return true;
        }
      }
      if(companyDetails.createdBy.split('@')[1].trim() == domain){
        return true;
      }

      if(companyDetails.domainName == domain){
        return true;
      }
      // if(companyDetails.type && companyDetails.type.indexOf('coworking')>=0){
      //   if(companyDetails.additionalDomains && companyDetails.additionalDomains.length<=0){
      //     return true
      //   }
      // }
      let isForAllOffices = companyDetails.additionalDomains && companyDetails.additionalDomains.length>0 ? companyDetails.additionalDomains[0].forAllOffices : false
      
      
      let allDomainList = [];
      
      console.log('allOfficeDomains----',allDomainList)
      if(isForAllOffices || checkAllOffices){
        let domainsArray = companyDetails.additionalDomains.map(item => item.domainsList.map(item => item.domain));
        for(let item of domainsArray){
          allDomainList.push(...item)
        }
        
        if(allDomainList.indexOf(domain)>=0){
          return true;
        }else{
          return false;
        }
      
      }

      

      if(officeId){
        let officeDomains = companyDetails.additionalDomains && companyDetails.additionalDomains.length>0 ? companyDetails.additionalDomains.find(item => item.officeId == officeId) : null

        if(officeDomains){
          officeDomains = officeDomains.domainsList
          officeDomains = officeDomains.map(item => item.domain);
        }else{
          officeDomains = []
        }

        

        if(officeDomains.indexOf(domain)>=0){
          return true
        }else{
          return false;
        }

      }

      // check for super admin
      

      console.log('company details ==> ', this.companyService.companyDetails)
      return false
    }

    getOfficeIdsOfDomain(email, company = null, domainName = null):any {
      console.log('email====',email,this.companyService.companyDetails.domainName)
      if(!email){
        return false;
      }
      let domain = domainName ? domainName : email.toLowerCase().trim().split('@')[1]
      let companyDetails = this.companyService.companyDetails;
      if(!companyDetails){
        companyDetails = company
      }
      if(!companyDetails){
        return false
      }
      if(companyDetails.domainName == domain){
        return null;
      }
      if(companyDetails.createdBy && companyDetails.createdBy.split('@')[1] == domain){
        return null;
      }
      if(companyDetails.additionalDomains && companyDetails.additionalDomains.length>0){
        let officeIds = []
        for(let list of companyDetails.additionalDomains){
          for(let domainName of list.domainsList){
            if(domainName.domain == domain){
              if(list.forAllOffices){
                return null;
              }
              officeIds.push(list.officeId)
            }
          }
        }
        if(officeIds && officeIds.length>0){
          return officeIds
        }else{
          return false;
        }

      }

      return false

    }

    validateUserForAdminAccess(email){
      if(!email){
        return false;
      }
      let domain = email.toLowerCase().trim().split('@')[1]
      let companyDetails = this.companyService.companyDetails;
      if(companyDetails.domainName == domain){
        return null;
      }
    }
    getVisitCategories(categories){
      // let categories = [1,2,4]
      let dat = [
        {
          type:1,
          reason: 'I work here',
          selected: false
        },
        {
          type:2,
          reason:'Meeting Appointment',
          selected: false
        },
        {
          type:3,
          reason: 'Delivery',
          selected: false
        },
        {
          type:4,
          reason:'Service',
          selected: false
        },
        {
          type:5,
          reason:'Other',
          selected: false
        }
      ]
      let temp = []
      dat.forEach(element => {
        if(categories.indexOf(element.type)>-1){
          temp.push(element)
        }
      });
      console.log(temp)
      return temp
    }
    getVisitPurpose(categories){
      let temp = []
      categories.forEach(element => {
        if(element.isActive){
          element['selected'] = false
          temp.push(element)
        }
      });
      return temp
    }

    loadJquery(){
      let head = document.getElementsByTagName('HEAD')[0];
  
      let link = document.createElement('script');
      let link1 = document.createElement('script');
  
      // set the attributes for link element
      // link.rel = 'stylesheet';
      link.type = 'text/javascript';
      link1.type = 'text/javascript';
      link.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
      link1.src = 'https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js';
  
      // Append link element to HTML head
      head.appendChild(link);
      head.appendChild(link1);
  }
  loadBootstrapCss() {
    let head = document.getElementsByTagName('HEAD')[0];
  
    let link = document.createElement('link');
    link.rel = 'stylesheet';
   
    link.href = 'https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css';
   
    // Append link element to HTML head
    head.appendChild(link);
  }
  loadJquery3dot7(){
    let head = document.getElementsByTagName('HEAD')[0];

    let link = document.createElement('script');
    let link1 = document.createElement('script');

    // set the attributes for link element
    // link.rel = 'stylesheet';
    link.type = 'text/javascript';
    link1.type = 'text/javascript';
    link.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    link1.src = 'https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js';

    // Append link element to HTML head
    head.appendChild(link);
    head.appendChild(link1);
}
  getOfficesForProduct(offices, productCode=null){
    if(!offices){
      return [];
    }

    if(!productCode){
      return offices.filter(item => item.isActive && item.products && Array.isArray(item.products) && item.products.filter(item => item.isActive).length>0 && (( item.isBulding==true && (!item.mergeObj || !item.mergeObj.status)) ||  !item.isBulding));
    }
    const officeList = []
    
    for(let i=0;i<offices.length;i++){

      const office = offices[i];

      if(office.isActive){

        if(office.isBulding==true && office.mergeObj && office.mergeObj.status){
          continue;
        }

        if(office.products && office.products.length > 0){

          let productExists = office.products.find(product => product.productCode == productCode && product.isActive);

          if(productExists){
            if(productCode == 1 && this.checkOfficeAllFloorsIsActive(office.floorDetails)){
              officeList.push(office);
            }
            if(productCode == 2){
              officeList.push(office);
            }
            if(productCode == 3 || productCode == 4){
              officeList.push(office);
            }
            // if(productCode == 4){
            //   officeList.push(office);
            // }
            continue;
          }

        }else{

          if(productCode == 1 && !office.isBulding && this.checkOfficeAllFloorsIsActive(office.floorDetails)){
            officeList.push(office);
          }

          if(productCode == 2 && office.isBulding){
            officeList.push(office);
          }

        }



      }

    }

    return officeList;

  }
  getAllOfficesForProduct(offices, productCode=null){
    if(!offices){
      return [];
    }

    if(!productCode){
      return offices.filter(item => item.products && Array.isArray(item.products) && item.products.filter(item => item.isActive).length>0 && (( item.isBulding==true && (!item.mergeObj || !item.mergeObj.status)) ||  !item.isBulding));
    }
    const officeList = []
    
    for(let i=0;i<offices.length;i++){

      const office = offices[i];

      // if(office.isActive){

        if(office.isBulding==true && office.mergeObj && office.mergeObj.status){
          continue;
        }

        if(office.products && office.products.length > 0){

          let productExists = office.products.find(product => product.productCode == productCode && product.isActive);

          if(productExists){
            if(productCode == 1 && this.checkOfficeAllFloorsIsActive(office.floorDetails)){
              officeList.push(office);
            }
            if(productCode == 2){
              officeList.push(office);
            }
            if(productCode == 3 || productCode == 4){
              officeList.push(office)
            }
            continue;
          }

        }else{

          if(productCode == 1 && !office.isBulding && this.checkOfficeAllFloorsIsActive(office.floorDetails)){
            officeList.push(office);
          }

          if(productCode == 2 && office.isBulding){
            officeList.push(office);
          }

          if(productCode == 3 || productCode == 4){
            officeList.push(office)
          }

        }



      // }

    }

    return officeList;

  }

  checkOfficeAllFloorsIsActive(dat){
    let temp = false
    dat.forEach(element => {
      if(element.isActive){
        temp = true
        return temp
      }
    });
    return temp
  }
  getProductSettingFromOffice(office, productCode, settingName = null){
    if(!office || !office.products || !productCode || !Array.isArray(office.products)){
      return null;
    }
    let setting = null;
    let product = office.products.find(item => item.productCode == productCode);
    if(settingName){
      if(product && product.settings && Array.isArray(product.settings)){
        setting = product.settings.find(item => item.name == settingName)
      }
    }else{
      setting = product.settings
    }
    return setting;
  }
  componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  
  rgbToHex(rgbColor) {
    console.log('rgbColor------',rgbColor)
    rgbColor = rgbColor.slice(4,rgbColor.length-1).split(',')
    return "#" + this.componentToHex(Number(rgbColor[0])) + this.componentToHex(Number(rgbColor[1])) + this.componentToHex(Number(rgbColor[2]));
  }

  checkIfAddonExistsInAOffice(office, addOnCode){
    if(!office){
      return false
    }
    if(!addOnCode){
      return false;
    }

    if(office.products && Array.isArray(office.products)){
      for(let product of office.products){
        if(product.isActive && product.addOns && Array.isArray(product.addOns)){
          let addOnExist = product.addOns.find(item => item.isActive && item.code == addOnCode);
          if(addOnExist){
            return addOnExist;
          }
        }
      }
    }
    return false

  }
  dynamicFieldsValidation(customInformation){
    let validationDetails = {
      validationFailed : false,
      errorMsg : null
    }
    console.log('customInformation----1----',customInformation)
    for(let i=0;i<customInformation.length;i++){
      if(!customInformation[i].isActive){
        continue;
      }
      if(customInformation[i]['skipValidation']){
        continue;
      }
      if(customInformation[i].value == ''){
        customInformation[i].value == null
      }
      if(customInformation[i].inputType != 'dropdown' && customInformation[i].inputType != 'date' && customInformation[i].inputType != 'document' && customInformation[i].inputType != 'number'  && customInformation[i].inputType != 'email' && customInformation[i].isActive && customInformation[i].mandatory){


        if(!customInformation[i].value || customInformation[i].value == ''){

            validationDetails.errorMsg = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase()
            validationDetails.validationFailed = true
            break

        }else if(customInformation[i].inputType != 'dropdown'){

            if(customInformation[i].minLength && customInformation[i].value?.length<customInformation[i].minLength){
              validationDetails.errorMsg = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase() + ' Min - ' + customInformation[i].minLength+ ' chars'
              validationDetails.validationFailed = true
              break
            }
            if(customInformation[i].maxLength && customInformation[i].value?.length > customInformation[i].maxLength){
              validationDetails.errorMsg = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase() + ' Max - ' + customInformation[i].maxLength+ ' chars'
              validationDetails.validationFailed = true
              break
            }

        
        }

       
      }
      else if(customInformation[i].inputType == 'number' && customInformation[i].isActive && customInformation[i].mandatory && (!customInformation[i].value || Number(customInformation[i].value) < customInformation[i]?.minLength)){
       
        validationDetails.errorMsg  = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase() 
        if(customInformation[i].minLength){
            validationDetails.errorMsg +=  ' Min - ' + customInformation[i].minLength
        }
        validationDetails.validationFailed  = true
        break
      }else if(customInformation[i].inputType == 'email' && customInformation[i].isActive && !customInformation[i].mandatory && customInformation[i].value && !this.validateEmail(customInformation[i].value)){
        validationDetails.errorMsg = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase()
        validationDetails.validationFailed = true
        break
      }
      else if(customInformation[i].inputType == 'email' && customInformation[i].isActive && customInformation[i].mandatory && !this.validateEmail(customInformation[i].value)){
        validationDetails.errorMsg = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase()
        validationDetails.validationFailed = true
        break
      }else if(customInformation[i].inputType == 'document' &&  customInformation[i].isActive && customInformation[i].mandatory && (!customInformation[i].value || (Array.isArray(customInformation[i].value) && customInformation[i].value.length == 0))){
        validationDetails.errorMsg = "Please upload " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please|upload|Upload)/g, '').toLowerCase()
        validationDetails.validationFailed = true
        break
      }
      else if(customInformation[i].inputType == 'date' &&  customInformation[i].isActive && customInformation[i].mandatory && !customInformation[i].value){
        validationDetails.errorMsg = "Please select " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please|select|Select)/g, '').toLowerCase()
        validationDetails.validationFailed = true
        break
      }
      else if(customInformation[i].inputType == 'dropdown' &&  customInformation[i].isActive && customInformation[i].mandatory){
        if(!customInformation[i].value){
          validationDetails.errorMsg = "Please select " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please|select|Select)/g, '').toLowerCase()
          validationDetails.validationFailed = true
          break  
        }else {
          let conditionalInputs = customInformation[i].conditionalInputs?.find(item => item.isActive && item.mandatory && !item.value && this.haveCommonValues(item.matchValues, customInformation[i].value));
          if(conditionalInputs){
              validationDetails.errorMsg = "Please enter/upload valid " + conditionalInputs.inputTitle.replaceAll(/(Enter|enter|Please|please|upload|Upload)/g, '').toLowerCase()
              validationDetails.validationFailed = true
            break  
          }

        }
        
      }
      // else if(customInformation[i].inputType == 'dropdown' && customInformation[i].isActive && customInformation[i].mandatory && customInformation[i].value?.length<customInformation[i]?.minLength){
      //   validationDetails.errorMsg  = "Please enter valid " + customInformation[i].inputTitle.replaceAll(/(Enter|enter|Please|please)/g, '').toLowerCase()
      //   validationDetails.validationFailed  = true
      //   break
      // }
    }
    return validationDetails
  }
  addFieldsValidation(customInformation){
    let validationDetails = {
      validationFailed : false,
      errorMsg : null
    }
    console.log('customInformation-----',customInformation)
    let allFieldsDeactivated = true;
    for(let i=0;i<customInformation.length;i++){

      if(customInformation[i].isActive){
        allFieldsDeactivated = false
      }
      if(!customInformation[i].inputType){
          validationDetails.errorMsg = "Please select field type"
          validationDetails.validationFailed = true
          break
      }else if(!customInformation[i].inputTitle){
        validationDetails.errorMsg = "Please enter field title"
        validationDetails.validationFailed = true
        break
      }else if(!customInformation[i].placeholder){
        validationDetails.errorMsg = "Please enter field placeholder"
        validationDetails.validationFailed = true
        break
      }else if(customInformation[i].inputType !='declaration' && customInformation[i].inputTitle.length>45){
        validationDetails.errorMsg = "Input title should be less than 45 characters"
        validationDetails.validationFailed = true
        break
      }
      else if(customInformation[i].inputType !='declaration' && customInformation[i].placeholder.length>45){
        validationDetails.errorMsg = "Input placeholder should be less than 45 characters"
        validationDetails.validationFailed = true
        break
      }
      if(customInformation[i].inputType == 'dropdown' && (!customInformation[i].dropdownList || customInformation[i].dropdownList.length<=1)){
        validationDetails.errorMsg = "Add atleast two options for dropdowns"
        validationDetails.validationFailed = true
        break
      }
    }
    if(allFieldsDeactivated){
      validationDetails.errorMsg = "All fields should not be deactivated."
        validationDetails.validationFailed = true
    }
    return validationDetails
  }
  submitField(customFields,existingSettings){
    console.log('customFields===',customFields)
    for(let i=0;i<customFields.length;i++){
      console.log(customFields[i])
      if(!customFields[i].inputType || customFields[i].inputType == ''){
        alert("Please select field Type")
        return
      }else if(!customFields[i].inputTitle || customFields[i].inputTitle == ''){
        alert("Please enter input title")
        return
      }
      if(!customFields[i].referenceName){
        customFields[i].referenceName = this.camelize(customFields[i].inputTitle) 
      }
      let referenceNameExist = existingSettings.findIndex((ele)=> ele.referenceName == customFields[i].referenceName )
      // if(referenceNameExist==-1){
        existingSettings.push(customFields[i])
      // }else{
        // existingSettings[referenceNameExist] = customFields[i]
      // }
    }
    return existingSettings
  }
  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }
  getReadableDate(date,timezone= null, format='DD/MM/YYYY'){
    // let timezone = location?.timezone?.name

    if(!timezone){
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    }
    return  moment(date).tz(timezone).format(format);

    // let name = moment('2023-07-26T10:25:14.479Z').tz("Europe/Athens").format("h:mm a");
    // return name;
    // if(!locationInfo){
    //   timezone:'Asia/Culcutta'
    // }
  }
  getViewImagesUrlFromFeedbackComplaint(field, userName){
    console.log('field===',field)
    if(!field || !field.value || field.value.length<=0){
      return 
    }
    // field.value = ['https://qdesq.imagekit.io/image/upload/v1693311394/Qudify/flpjlhodl0b9tfvdebf3.png','https://qdesq.imagekit.io/image/upload/v1693311394/Qudify/flpjlhodl0b9tfvdebf3.png','https://qdesq.imagekit.io/image/upload/v1693311394/Qudify/flpjlhodl0b9tfvdebf3.png']
    // field.title ="Hello"
    // let domain = 'https://test.qudify.co/'
    // let images = field.value.map(item => item.split('https://ik.imagekit.io/')[1]).join(',')
    let images = field.value.join(',')
    let url = '/view-images/images?userName='+userName+'&title='+field.title+'&images='+images;
    console.log('url===',url)
    return url;
  }

  rotate(srcBase64, degrees, callback) {
    const canvas = document.createElement('canvas');
    const ctx    = canvas.getContext('2d');
    const image  = new Image();
  
    image.onload = function () {
      canvas.width  = degrees % 180 === 0 ? image.width : image.height;
      canvas.height = degrees % 180 === 0 ? image.height : image.width;
  
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(degrees * Math.PI / 180);
      ctx.drawImage(image, image.width / -2, image.height / -2);
  
      callback(canvas.toDataURL());
    };
  
    image.src = srcBase64;
  }
  isLinkedToEmployeeActiveDirectory(company){
    return company?.thirdPartyIntegrationDetails?.integrations?.find(item => item.isActive && item.intergrationType == 'activeDirectory')
  }

  getCookie(cname) { 
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  getGclid(){
    var gclid = null;
    var queryUrl = window.location.search;
    var urlSearchParams = new URLSearchParams(queryUrl);
    gclid = urlSearchParams.get('gclid')
    if(gclid && typeof(gclid)=='string' && gclid.length>5){
      return gclid;
    }else{
      var coockies:any = this.getCookie('_gcl_aw');
      if(coockies && coockies.length>5){
        coockies = coockies.split('.');
        gclid = coockies[coockies.length-1];
      }
    }
  return gclid;
  }

  getDefaultVisitorCheckinDeclaration(){
    return {
      isActive: true,
      displayText:'<p>By continuing, I agree to Qudify’s <a style="color:black !important;text-decoration:underline;" href=\"https://qudify.co/terms-of-service\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Use</a> and <a style="color:black !important;text-decoration:underline;" href=\"https://qudify.co/privacy-policy\" rel=\"noopener noreferrer\" target=\"_blank\">Privacy policy</a>.</p>',
      document: {
        url: null,
        name: null
      }
    }
  }
  downloadExcelFromApi(type,params,fileName,callback,fullUrl=null){
    let url = `${type}/get/excel`
    if(fullUrl){
      url = fullUrl;
    }
    this.api.downloadDocument(url,params).subscribe((res:any)=>{
      if(!res.error){
        let url = res.body
        var link = document.createElement('a');
        link.href = window.webkitURL.createObjectURL(url);
        link.download =fileName;
        document.body.appendChild(link);
        callback(res)
        link.click();
        }
        else{
          callback({error:true,message:res.message})
        }
    },
    (err)=>{
      callback({error:true,message:err.error.message || err.message})
    }
    )
  }

  unsubscribeSubscriptions(allProps){
    for (const prop in allProps) {
      const property = allProps[prop];
      // Check if the property is a subscription
      if (property && typeof property.unsubscribe === 'function') {
         // Call the unsubscribe function to unsubscribe from the subscription
        property.unsubscribe();
      }
    }
  }

timeConverter(time) {
    console.log('time',time);
    if (time) {
        time = time.toString();
        if(time.length == 2){
          time = '0'+time;
          var hours = time[0];
          var min =time[1]+time[2];
        }
        else if (time.length == 3) {
            time = time;
            var hours = time[0];
            var min =time[1]+time[2];
        } else if (time.length == 4) {
            var hours = time[0] + time[1];
            var min = time[2] + time[3];
        }
        if (hours < 12) {
            if(hours=='0' && min=='00' ){
                return '12:00 AM';
            }else{
                return hours + ':'+ min+' AM';
            }

        } else {
            if(hours=='24' && min=='00'){
                return '12:00 AM';
            }
            hours = hours - 12;
            // hours = (hours.length < 10) ? '0' + hours : '0' + hours;
            return hours + ':'+ min+' PM';
        }
    }
}
  getOfficeTime(office, onlyEnd = false){
    let days = ['sun','mon','tue','wed','thu','fri','sat'];

    let currentDay = days[new Date().getDay()];

    if(!office.officeHours[currentDay].from || !office.officeHours[currentDay].to){
      return 'Closed';
    }else {
      if(onlyEnd){
        return this.timeConverter(office.officeHours[currentDay].to)
      }
      return this.timeConverter(office.officeHours[currentDay].from) + " - "+ this.timeConverter(office.officeHours[currentDay].to)
    }
  }
  getOfficeCloseDays(office) {
      let closeDays = [];
      if(!office.officeHours?.mon?.from || !office.officeHours?.mon?.to){
        closeDays.push('Monday')
      }
      if(!office.officeHours?.tue?.from || !office.officeHours?.tue?.to){
        closeDays.push('Tuesday')
      }
      if(!office.officeHours?.wed?.from || !office.officeHours?.wed?.to){
        closeDays.push('Wednesday')
      }
      if(!office.officeHours?.thu?.from || !office.officeHours?.thu?.to){
        closeDays.push('Thursday')
      }
      if(!office.officeHours?.fri?.from || !office.officeHours?.fri?.to){
        closeDays.push('Friday')
      }
      if(!office.officeHours?.sat?.from || !office.officeHours?.sat?.to){
        closeDays.push('Saturday')
      }
      if(!office.officeHours?.sun?.from || !office.officeHours?.sun?.to){
        closeDays.push('Sunday')
      }
      
      return closeDays;
  }

  maskEmail(email) {
    if(!email){
      return
    }
    let maskedEmail = ''
    for(let i=0;i<email.split('@')[0].length;i++){
      maskedEmail = maskedEmail + (i%2 == 1 ? '*' :email.split('@')[0][i])
    }
    maskedEmail = maskedEmail +'@' + email.split('@')[1]

    return maskedEmail;
  }
  maskContactNumber(dat){
    if(!dat){
      return;
    }
    dat = dat.toString()
    // console.log(dat)
    let number = "******" + dat.substring(dat.length-4,dat.length)
    return number
  }
  usersAvatarImg(name){
    return 'https://ui-avatars.com/api/?name=' +
    name +'&background='+'random' +'&length=2' +'&bold=' +true +'&rounded=' +true
  }

  validateVisitHostDetails(office, visitsData){

    let notificationToHostSetting = 'whatsapp'
    let notificationToHostSettingExist = this.getProductSettingFromOffice(office,2,'visitor-meeting-appointment-approval-notification')
    if(notificationToHostSettingExist){
      notificationToHostSetting = notificationToHostSettingExist.value
    }

    if(!notificationToHostSetting || notificationToHostSetting == 'whatsapp'){

      if(!visitsData.details['contactNumber']){
        return 'Phone number not found in host details'
        return
      }else if(visitsData.details['contactNumber'] && !this.validation.validatePhoneNumber(visitsData.details['contactNumber'], visitsData.details['maxValidContactNumberLength'], visitsData.details['minValidContactNumberLength'])){
        return 'Phone number is not valid in host details'
      }

    }
    else if(notificationToHostSetting == 'email'){
      if(!visitsData.details['hostEmail']){
        return 'Email id not found in host details'
      }else if(visitsData.details['hostEmail'] && !this.validateEmail(visitsData.details['hostEmail'])){
        return 'Email id is not valid in host details'
      }
    }
    else if(notificationToHostSetting == 'all'){
      if((visitsData.details['hostEmail'] && !this.validateEmail(visitsData.details['hostEmail'])) || (visitsData.details['contactNumber'] && !this.validation.validatePhoneNumber(visitsData.details['contactNumber'], visitsData.details['maxValidContactNumberLength'], visitsData.details['minValidContactNumberLength']))){
        
      }else if(visitsData.details['hostEmail'] && !this.validateEmail(visitsData.details['hostEmail'])){
        return 'Email id or phone number not found in host details'
      }
    }

    return null;

  }
    createCookie(name,value,days) {
      if (days) {
          let date = new Date();
          date.setTime(date.getTime()+(days* 24 * 60 * 60 * 1000));
          var expires = "; expires="+date.toUTCString();
      } else {
          var expires = "";
      }
      document.cookie = name+"="+value+expires+"; path=/";
    }
    getCompaignParameterCookie(name) {
      var value = `; ${document.cookie}`;
      var parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    detectDeviceType(){
      const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
      const platform = typeof navigator !== 'undefined' ? navigator.platform || '' : '';
      const isIPadOS = platform === 'MacIntel' && navigator.maxTouchPoints > 1;

      // Returns apple, window, or android. iPadOS identifies itself as a Mac in desktop mode.
      if (/iPad|iPhone|iPod/i.test(userAgent) || isIPadOS || /Macintosh|Mac OS X/i.test(userAgent)) {
        return 'apple';
      }

      if (/Windows|IEMobile|Windows Phone/i.test(userAgent)) {
        return 'window';
      }

      return 'android';
    }

    getCategoryNameFromPassConfiguration( categoryCode, company, preInvite, officeDetails = null ) {
      try {
    
        if ( categoryCode ) {
          const configuration = this.getPassConfiguration(company, officeDetails);
          let passConfiguration = []
          if ( preInvite ) passConfiguration = configuration?.isActive && configuration?.preInvitePass ? configuration.preInvitePass : []
          else passConfiguration = configuration?.isActive && configuration?.visitorPass ? configuration.visitorPass : []
          let item = passConfiguration.find(item => item.code == categoryCode )
          let categoryName = item ? item.displayName : this.categoryType(categoryCode)
          return categoryName
        }
        return null
        
      } catch (error) {

      } 
    }
    categoryType(type) {
      // try catch block for errors and exceptions handling start here
      switch (type) {
        case 1:
          return 'i work here';
    
        case 2:
          return 'meeting appointment';
    
        case 3:
          return 'delivery';
    
        case 4:
          return 'service';
    
        case 5:
          return 'other';
    
        case 6:
          return 'company pass';
    
        case 7:
          return 'vip';
    
        case 8:
          return 'access pass';
    
        case 9:
          return 'event pass'; // earlier member pass
    
        default:
          return 'other';
      }
    }
    isCompanyLinkedToThirdParty(company, type){
      return company?.thirdPartyIntegrationDetails?.integrations?.find(item => item.thirdPartyName == type)
    }

    getCategoryCodeFromVisit(visit){
      if(!visit || !visit.category){
        return;
      }

      return visit.category.similarToCode || visit.category.code

    }

    isValidMongoId(id) {
      // Check if the input is a string and has exactly 24 characters
      if (typeof id !== 'string' || id.length !== 24) {
        return false;
      }
    
      // Check if the string contains only hexadecimal characters
      const hexPattern = /^[a-fA-F0-9]{24}$/;
      return hexPattern.test(id);
    }
    encodeJWTToken(token){
          var newToken = token.substring(0,12)+'xss'+token.substring(12,token.length);
          newToken = window.btoa(newToken);
          return newToken;
      
    }

    decodeJWTToken(token){
      if(token){
          var decryption1 = window.atob(token);
          var decryption2 = decryption1.substring(0,12)+decryption1.substring(15,decryption1.length);
          return decryption2;
      }
    
    }

    haveCommonValues(arr1, arr2) {
      if(arr1 && arr2){
        return arr1.some(item => arr2.includes(item?.trim()));
      }
     
    }
    isCurrentTimeWithinOfficeHours(currentDateTime, officeHours){
      try {
    
        const currentDate = new Date(currentDateTime);
        const currentDay = currentDate.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();
        const currentTime = currentDate.getHours() * 100 + currentDate.getMinutes();
    
        if (currentDay in officeHours) {
          const { from, to } = officeHours[currentDay];
    
          // Check if the current time is within the specified range
          if (currentTime >= from && currentTime <= to) {
            return true;
          }
        }
    
        return false
    
      } catch (error) {
       
      }
    }
    isLandscape() {
      return window.innerWidth > window.innerHeight;
    }
    isMaskingEnabledInAnyOffice(offices, role) {

      if(offices?.length){
  
          for(let office of offices){
  
              let product = office.products.find(item => item.productCode == '2');
  
              if(product?.maskedInformation?.length){

                if(product?.maskedInformation?.find(item => item.role == role)){
                  return true
                }else{
                  continue;
                }
  
              }
  
  
          }
  
      }
      return false;
  
    }

    checkForVisitorDesignationText(selectedVisit){
      console.log('eeeee = ', selectedVisit)
      if(selectedVisit && selectedVisit?.visitDetails?.preVisit && (selectedVisit?.visitDetails?.category?.code == 2 || selectedVisit?.category?.visitDetails?.similarToCode == 2)){
  
          return OfficeIdsForAddingVisitorDesignationInMAPreInvitePass.find(item => item.officeId == selectedVisit?.visitDetails?.officeId);

      }
   }

   addOfficeWisePreInviteCategories(officeId, categories, inActiveCategories = []){



    if(officeId == '67987fc38e291aa4cec5a25d' || officeId == '6790cadbba79336f1fd8ee52' || officeId == '6971ed52d9a60bd9d1df2af3' || officeId == '693bbaec86949078be9a3d04' || JLL_UK_offices?.includes(officeId)){

      categories.push({
            name: 'Job Interview',
            selected:false,
            code:2,
            categoryName:'Job Interview'
      })
      // categories.push({
      //   name: 'JLL Employee Visit',
      //   selected:false,
      //   code:6,
      //   categoryName:'JLL Employee Visit'
      // })
        categories.push({
              name: 'Service Partner',
              selected:false,
              code:2,
              categoryName:'Service Partner'
        })
        categories.push({
          name: 'Other',
          selected:false,
          code:2,
          categoryName:'Other'
      })

    }

    let officeWiseCategoriesExist = customOfficeWisePreInvitePassCategories?.find(item => item.officeId == officeId)

    console.log('officeWiseCategoriesExist === ', officeWiseCategoriesExist, inActiveCategories)
     if(officeWiseCategoriesExist && categories?.length){

        if(inActiveCategories){
          inActiveCategories = JSON.parse(JSON.stringify(inActiveCategories));
        }
         inActiveCategories.forEach(pass => {

          if(officeWiseCategoriesExist.categoriesEncluded?.length){

            let isPassTypeIncluded = officeWiseCategoriesExist.categoriesEncluded?.find(type => type._id == pass._id);
            
            if(isPassTypeIncluded ){
              pass.isActive = true;
              categories.push(pass)
            }else {
              if(!officeWiseCategoriesExist.includeDefaultCategories){
                pass.isActive = false;
              }
              
            }

          }
          

          if(officeWiseCategoriesExist.categoriesExcluded?.length){

            officeWiseCategoriesExist.categoriesExcluded.forEach(type => {

              let isPassTypeExcluded = categories.find(category => type._id == category._id);

              if(isPassTypeExcluded ){
                pass.isActive = false;
              }

            })

            

          }
          

         })

    }

    console.log('categories after custom', categories)

   }
   addOfficeWisePreInviteCategoriesForEmployees(officeId, categories, inActiveCategories=[]){


    if(officeId == '67987fc38e291aa4cec5a25d' || officeId == '6790cadbba79336f1fd8ee52'  || officeId == '6971ed52d9a60bd9d1df2af3' || officeId == '693bbaec86949078be9a3d04' || JLL_UK_offices?.includes(officeId)){

      // categories.push({
      //       name: 'Job Interview',
      //       selected:false,
      //       code:2,
      //       category:2,
      //       isActive:true
      // })

      categories.push({
        name : 'Job Interview',
        code : 2,
        similarToCode: 2,
        description : 'Pre approved Visitor will be required to check-in on arrival.',
        selected : true,
        isActive: true
      })

      // categories.push({
      //   name: 'JLL Employee Visit',
      //   selected:false,
      //   code:6,
      //   category:'JLL Employee Visit'
      // })
        // categories.push({
        //       name: 'Service Partner',
        //       selected:false,
        //       code:2,
        //       category:2,
        //       isActive:true
        // })
      //   categories.push({
      //     name: 'Other',
      //     selected:false,
      //     code:2,
      //     category:2,
      //     isActive:true
      // })

      categories.push({
        name : 'Other',
        code : 2,
        similarToCode: 2,
        description : 'Pre approved Visitor will be required to check-in on arrival.',
        selected : true,
        isActive: true
      })


    }

    if(officeId == '67af2c465118c11c97d42f43'){

      // categories.push({
      //       name: 'Interview',
      //       selected:false,
      //       code:2,
      //       category:2,
      //       isActive:true
      // })
      

    }

    let officeWiseCategoriesExist = customOfficeWisePreInvitePassCategories?.find(item => item.officeId == officeId)

     console.log('officeWiseCategoriesExist === ', officeWiseCategoriesExist, inActiveCategories)
     if(officeWiseCategoriesExist && categories?.length){

        if(inActiveCategories){
          inActiveCategories = JSON.parse(JSON.stringify(inActiveCategories));
        }
         inActiveCategories.forEach(pass => {

          if(officeWiseCategoriesExist.categoriesEncluded?.length){

            let isPassTypeIncluded = officeWiseCategoriesExist.categoriesEncluded?.find(type => type._id == pass._id);
            
            if(isPassTypeIncluded ){
              pass.isActive = true;
              categories.push(pass)
            }else {
              if(!officeWiseCategoriesExist.includeDefaultCategories){
                pass.isActive = false;
              }
              
            }

          }
          

          if(officeWiseCategoriesExist.categoriesExcluded?.length){

            officeWiseCategoriesExist.categoriesExcluded.forEach(type => {

              let isPassTypeExcluded = categories.find(category => type._id == category._id);

              if(isPassTypeExcluded ){
                pass.isActive = false;
              }

            })

            

          }
          

         })

    }

    console.log('categories after custom', categories)

   }

   checkOfficeWiseCategoryPassColor(officeId, visit) {


    console.log('visitPass====', visit)
    if(officeId == '67987fc38e291aa4cec5a25d' || officeId == '6790cadbba79336f1fd8ee52' ||  officeId == '6971ed52d9a60bd9d1df2af3' || officeId == '693bbaec86949078be9a3d04' || JLL_UK_offices?.includes(officeId)){


        if(visit.category?.categoryName == 'Meeting Appointment'){
          return  '#498D54' //  '#43884E'
        }

        if(visit.category?.categoryName?.toLowerCase()?.includes('VIP')){
          return '#E4B241' // 'linear-gradient(89.96deg, rgb(222, 168, 54) 0.04%, rgb(228, 179, 62) 15.39%, rgb(223, 189, 84) 31.21%, rgb(250, 222, 118) 47.48%, rgb(240, 207, 103) 55.97%, rgb(215, 178, 73) 74.83%, rgb(222, 168, 54) 85.34%, rgb(225, 174, 58) 97.7%, rgb(227, 176, 60) 104.12%, rgba(191, 140, 32, 0) 121.76%)' // '#FDDC5C'
        }

        if(visit.category?.categoryName == 'Service Partner'){
          return '#083F66' //'linear-gradient(89.96deg, rgb(222, 168, 54) 0.04%, rgb(228, 179, 62) 15.39%, rgb(223, 189, 84) 31.21%, rgb(250, 222, 118) 47.48%, rgb(240, 207, 103) 55.97%, rgb(215, 178, 73) 74.83%, rgb(222, 168, 54) 85.34%, rgb(225, 174, 58) 97.7%, rgb(227, 176, 60) 104.12%, rgba(191, 140, 32, 0) 121.76%)' // '#FDDC5C'
        }

        if(visit.category?.categoryName == 'Other'){
          return '#ADD8E6' //'linear-gradient(89.96deg, rgb(222, 168, 54) 0.04%, rgb(228, 179, 62) 15.39%, rgb(223, 189, 84) 31.21%, rgb(250, 222, 118) 47.48%, rgb(240, 207, 103) 55.97%, rgb(215, 178, 73) 74.83%, rgb(222, 168, 54) 85.34%, rgb(225, 174, 58) 97.7%, rgb(227, 176, 60) 104.12%, rgba(191, 140, 32, 0) 121.76%)' // '#FDDC5C'
        }

        if(visit.category?.categoryName == 'Job Interview'){
          return '#0C7394' // 'linear-gradient(89.96deg, rgb(222, 168, 54) 0.04%, rgb(228, 179, 62) 15.39%, rgb(223, 189, 84) 31.21%, rgb(250, 222, 118) 47.48%, rgb(240, 207, 103) 55.97%, rgb(215, 178, 73) 74.83%, rgb(222, 168, 54) 85.34%, rgb(225, 174, 58) 97.7%, rgb(227, 176, 60) 104.12%, rgba(191, 140, 32, 0) 121.76%)' // '#FDDC5C'
        }


        if(visit.category?.categoryName == 'JLL Employee Visit'){
          return '#E0434E' //  '#2C7D80'
        }

        if(visit.category?.categoryName == 'Job Interview'){
          return  '#0C7394'  //'linear-gradient(89.96deg, rgb(222, 168, 54) 0.04%, rgb(228, 179, 62) 15.39%, rgb(223, 189, 84) 31.21%, rgb(250, 222, 118) 47.48%, rgb(240, 207, 103) 55.97%, rgb(215, 178, 73) 74.83%, rgb(222, 168, 54) 85.34%, rgb(225, 174, 58) 97.7%, rgb(227, 176, 60) 104.12%, rgba(191, 140, 32, 0) 121.76%)' // '#FDDC5C'
        }
        if(visit.category?.categoryName == 'Job Interview'){
          return  '#0C7394' //  '#FDDC5C'
        }
        if(visit.category?.categoryName?.toLowerCase()?.includes('walkin appointment')){
          return  '#E0434E' //  '#FDDC5C'
        }

        

    }

  }

  endBookingBtnShow(data){
      if(data?.slot){
        let start = moment(data.slot.from,'YYYY-MM-DDTHH:mm:ss.SSS[Z]') 
        let end = moment(data.slot.to,'YYYY-MM-DDTHH:mm:ss.SSS[Z]') 
        let current = moment()
        // console.log(moment(current).isBetween(start,end))
        if(moment(current).isBetween(start,end)){
          return true
        }else{
          return false
        }
      }
  }


  addOfficeWiseCustomInputs(customInformation, officeId){

    if(officeId == '6780d8b2367279399c6b7131' || officeId == '68060e179a67bc7cdd97c1c2'){
      let input1 = {
        "mandatory": true,
        "userDefined": true,
        "isActive": true,
        "icon": "https://qdesq.imagekit.io/img/image/upload/v1646912132/wafuo9yd0jns5c4upf61.svg",
        "showInPass": true,
        "dropdownList": [],
        "conditionalInputs": [],
        "unFavorableResponses": [],
        "multiple": false,
        "autoFetch": false,
        "_id": "680625fe76887bcb10a1b85b",
        "inputTitle": "Official Email ID",
        "inputType": "email",
        "documentType": null,
        "referenceName": "employeeEmail",
        "maxLength": null,
        "createdAt": "2025-04-21T11:03:26.059Z",
        "updatedAt": "2025-04-21T11:03:26.059Z",
        domainMatchRequired: true,
        otpVerificationRequired: true
      }

      let input2 = {
          "mandatory": true,
          "userDefined": true,
          "isActive": true,
          "icon": "https://qdesq.imagekit.io/img/image/upload/v1646805667/evenndpdgo2jefv6xolv.svg",
          "showInPass": false,
          "dropdownList": [],
          "conditionalInputs": [],
          "unFavorableResponses": [],
          "multiple": false,
          "autoFetch": false,
          "_id": "680625fe76887bcb10a1b85c",
          "inputTitle": "OTP",
          "inputType": "number",
          "documentType": null,
          "referenceName": "employeeOTP",
          "maxLength": 4,
          "createdAt": "2025-04-21T11:03:26.059Z",
          "updatedAt": "2025-04-21T11:03:26.059Z"
      }

      // customInformation.splice(0,0,input2)
      customInformation.splice(0,0,input1);


      console.log('customInformation====',customInformation)


    }

    // jll uk office - 20 water salt

    if(officeId == "693bbaec86949078be9a3d04" || officeId == '6971ed52d9a60bd9d1df2af3' || JLL_UK_offices?.includes(officeId)){
      
      let options = [
                "Client Room 3.1 | 3rd Floor",
                "Client Room 3.2 | 3rd Floor",
                "Client Room 3.3 | 3rd Floor",
                "Client Rooms 3.1 & 3.2 | 3rd Floor",
                "Client Rooms 3.1 – 3.3 | 3rd Floor",
                "Client Room 3.4 | 3rd Floor",
                "Client Room 3.5 | 3rd Floor",
                "Client Room 3.6 | 3rd Floor",
                "Room 3.7 | 3rd Floor",
                "Room 3.10  | 3rd Floor",
                "Room 3.11 | 3rd Floor",
                "Room 3.12 | 3rd Floor",
                "Auditorium | 3rd Floor",
                "3rd Floor Collaboration Area | 3rd Floor",
                "Hybrid Room C - 3rd Floor | 3rd Floor",
                "Hybrid Room D - 3rd Floor | 3rd Floor",
                "Room 2.2 | 2nd Floor",
                "Room 2.3 | 2nd Floor",
                "Room 2.5 | 2nd Floor",
                "Room 2.4 | 2nd Floor",
                "Room 2.6 | 2nd Floor",
                "Room 2.7 | 2nd Floor",
                "Room 2.8 | 2nd Floor",
                "Room 2.9 | 2nd Floor",
                "Room 2.10 | 2nd Floor",
                "Room 2.11 | 2nd Floor",
                "Hybrid Room C - 2nd Floor | 2nd Floor",
                "Hybrid Room D - 2nd Floor | 2nd Floor",
                "2nd Floor Games Area | 2nd Floor"
          ]

      if(officeId == "69b2776eac2e016e25b8552a" || officeId == "69b91fdb0395ae371ee43beb" || officeId == '69bbd82f843c29882d92d4fa'){   // jll broadgate - live / test
        options = ['09.01','09.02','09.03','09.04','09.05','09.06','09.07','09.10','09.11','09.12','09.13','09.14','09.15','10.01','10.02','10.03','10.04','10.05','10.07','10.08','10.09','10. Townhall','10. Café','Reception','11.01','11.02','11.03','11.04','11.05','11.06','11.07 Multi-media Room','11.08','11.09','11.10','11.11','11.12','11.13','11.14','11.15','11.16','11.17','11.18','11.19']
              
      }

      let input1 = {
            "mandatory": true,
            "userDefined": true,
            "isActive": true,
            "icon": "https://qdesq.imagekit.io/image/upload/v1684834238/uox50dtstyye0kfvoyyy.svg",
            "showInPass": true,
            "dropdownList": options,
            "conditionalInputs": [],
            "unFavorableResponses": [],
            "multiple": false,
            "autoFetch": false,
            "_id": "696f73b194df92794898ac1d",
            "inputTitle": "Meeting Room",
            "inputType": "dropdown",
            "documentType": null,
            "referenceName": "meetingRoom",
            "skipValidation": true,
            "maxLength": null,
            "minLength": null,
            "createdAt": "2026-01-20T12:23:13.228Z",
            "updatedAt": "2026-01-20T12:23:13.228Z"
      }


      customInformation.splice(0,0,input1);



    }

  }
  phoneNumberFormat(dat){
    dat = dat.toString()
    // console.log(dat)
    let number = "******" + dat.substring(dat.length-4,dat.length)
    return number
  }

  refreshEasyWdmsVisit(companyDetails,callback){


    if(!this.isCompanyLinkedToThirdParty(companyDetails,'easyWdms')){
      callback(true)
      return;
    }

    let companyId = companyDetails?.id || companyDetails?._id;

    let dat = {
      companyId: companyId
    }

    if(!dat.companyId){
      callback(false);
      return;
    }

    this.api.post('visits/checkin/via/easywdms',dat).subscribe((res:any)=>{
        if(!res.error){
            if(callback){
              callback(true);
            }
        }
      },(err)=>{
        if(callback){
          callback(false);
        }
        
      })


  }
  convertCamelToTitle(text) {
    if(!text){
      return;
    }
    return text
      .replace(/([A-Z])/g, ' $1') // insert space before capital letters
      .replace(/^./, str => str.toUpperCase()); // capitalize first character
  }
  isValidISODate(dateString) {
    if(!dateString){
      return false;
    }
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  
    // First check format with regex
    if (!isoRegex.test(dateString)) {
      return false;
    }
  
    // Then try to parse it
    const date = new Date(dateString);
    return !isNaN(date.getTime()) && date.toISOString() === dateString;
  }

  getPageDescriptionForActivityLogs(activityName){
    // try catch block for errors and exceptions handling start here
        switch (activityName) {
          case 'singleDayPreInviteLogsExcel':
            return 'Check-In Management >> Pre Invites >> Single Day Logs >> Excel File';
      
          case 'singleDayLogsExcel':
            return 'Check-In Management >> Logs >> Excel File';
      
          case 'longtermPreInviteLogsExcel':
            return 'Check-In Management >> Pre Invites >> Long Term Logs >> Excel File';
      
          case 'meetingRoomBookingsLogsExcel':
            return 'Meeting Room & Desk >> Logs >> Excel File';
      
          case 'feedbackLogsExcel':
            return 'Feedback & Complaints >> Logs >> Feedback logs >> Excel File';
    
          case 'complaintsLogsExcel':
            return 'Feedback & Complaints >> Logs >> Complaint logs >> Excel File';
    
          case 'VMSQrCode':
            return 'Check-In Management >> Qr Code';
    
          case 'meetingRoomQrCode':
            return 'Meeting Room & Desk >> Qr Code';
    
          case 'feedbackAndComplaintsQrCode':
            return 'Feedback & Complaints >> Qr Code';
    
          case 'downloadEmployesList':
            return 'Employees >> Employee List >> Excel File';
    
          default:
            return '';
        } 
   }
   addActivityLog(companyId,officeId,activityType, pageDescription, payloadObject){

    let activity = {};

    if(activityType == 1){
      activity = {
        code:1,
        name:'Download'
      }
    }

    let payload = {
      companyId: companyId,
      officeId:officeId,
      activityType: activity,
      pageDescription: this.getPageDescriptionForActivityLogs(pageDescription),
      payloadDetails:  payloadObject
    }

    this.api.post('activityLogs',payload).subscribe((res:any)=>{
        if(!res.error){
           
        }
      },(err)=>{
       
        
      })


  }

  copyToClipboard(text){
    if(!text){
      return;
    }
    // var url = 'https://stage.qudify.co/visitor-checkin?refId='+ this.session.getUser().companyId
    const el = document.createElement('textarea')
    el.value =  text
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    el.remove()
   
  } 

  resetErrorMsg(object){
    if(object?.errorMsg){
      setTimeout(()=> {
       object.errorMsg = null;
    },5000)
    }
    
  }

  setCookie(key, value, days = 365){
     this.cookieService.set(key, value, {
        path: '/',
        expires: new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000), // 7 days
        secure: true,
        sameSite: 'Lax',
      });
  }


  getCustomInFormationsForPreInvitePasses(inputs, visit){

    let customInformation = []

    if(inputs?.length){


      for(let input of inputs){

         if(input.value){
            if(input.userDefined){
              let customInfoExist = customInformation.find((ele)=>ele.referenceName == input.referenceName)
              if(customInfoExist){
                customInfoExist.value = input.value
              }else{
                let dat = {
                  referenceName :  input.referenceName,
                  title :  input.inputTitle.replace(/(Enter|enter|Please|please)/g, ''),
                  value : input.value,
                  referenceId:  input._id || input.id
                }
                
                let conditionalInputs = input.conditionalInputs?.filter(item => item.isActive && item.value)
                if(conditionalInputs?.length){

                  dat['conditionalInputs'] = conditionalInputs?.map(item => ({ title: item.inputTitle, value: item.value, referenceId: item._id || item.id }))

                }
                
                customInformation.push(dat)
              }
            }else{

              if(input.referenceName == 'vehicleNumber'){
                  visit.additionalDetails[input.referenceName] = input.value
                
              }
              if(input.referenceName == 'empCode'){
                  visit.details[input.referenceName] = input.value
                
              }
              if(input.referenceName == 'visitorDesignation'){
                  visit.visitorDetails['designation'] = input.value
                
              }
              if(input.referenceName == 'visitorDepartment'){
                  visit.visitorDetails['department'] = input.value
                
              }



               if(input.referenceName == 'visitPurpose'){
                  visit.details[input.referenceName] = input.value
                
              } if(input.referenceName == 'description'){
                  visit.details[input.referenceName] = input.value
                
              } 
              

             
            }
          }


      }

    }

    return customInformation

   
  }
  areAllValuesFalsy(obj) {
    return Object.values(obj).every(value => !value);
  }

   checkIfScreenWiseCustomInputsInVMSExists(office,screenName){


       if(!office){
        return;
       }


       let product = office?.products?.find(item => item.productCode == 2);

       if(product){

            let customizedInfo = product?.customizedInformation.find(item => item.productCode == 2);

            if(customizedInfo){

                let screenCustomizations =  customizedInfo.screenCustomizations.find(item => item.screenName == screenName)

                return screenCustomizations?.screenCustomFields?.some(item => item.isActive);

            }


       }

       return false;


   }

   getDayOfMonthInTimezone(timezone='Asia/Kolkata', date=null) {
      // Get today's date in the given timezone

      const now = date ? new Date(date) : new date();
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        weekday: "long",
        year: "numeric",
        month: "numeric",
        day: "numeric"
      });
      
      // Break into parts
      const parts = formatter.formatToParts(now);
      const day = parseInt(parts.find(p => p.type === "day").value, 10);
      const weekday = parts.find(p => p.type === "weekday").value;

      // Figure out nth occurrence (1st, 2nd, 3rd...)
      const nth = Math.ceil(day / 7);

      // Format suffix (1st, 2nd, 3rd, 4th, 5th)
      const suffixes = ["", "first", "second", "third",'fourth','fifth'];
      const suffix =  suffixes[nth]  // nth < 4 ? suffixes[nth] : "th";

      return `${suffix} ${weekday}`;
  }

  getFeedbackAndComplaintsProductName(user, company , product, unchangedSideMenuProduct ){


    let labelSetting = FeedbackAndComplaintsUserFlowCustomizations.find(item => item.companyId === company?.id);



    if(user?.roles?.includes('Super Admin')){

      if(company?.products?.find(item => item.productCode == 3) && company?.products?.find(item => item.productCode == 4 )){

         return `${labelSetting?.Feedback?.shortLabel || 'Feedback'}  & ${labelSetting?.Complaint?.shortLabel || 'Complaints'}`

      }else if(company?.products?.find(item => item.productCode == 3) ){
         product.productCode = 3;
         this.hideFeedbackAndComplaintsSubMenu(product,4,unchangedSideMenuProduct)
          return `${labelSetting?.Feedback?.shortLabel || 'Feedback'}`
      }
      else if(company?.products?.find(item => item.productCode == 4) ){
         product.productCode = 4;
         this.hideFeedbackAndComplaintsSubMenu(product,3,unchangedSideMenuProduct)
          return `${labelSetting?.Complaint?.shortLabel || 'Complaints'}`
      }


    }


    if(user?.permissions?.length && user?.permissions?.find(item => item.productCode ==3 ) && user?.permissions?.find(item => item.productCode == 4 )){



      return `${labelSetting?.Feedback?.shortLabel || 'Feedback'}  & ${labelSetting?.Complaint?.shortLabel || 'Complaints'}`

    }
    else if(user?.permissions?.find(item => item.productCode ==3 )){
      product.productCode = 3;
      this.hideFeedbackAndComplaintsSubMenu(product,4,unchangedSideMenuProduct)
      return `${labelSetting?.Feedback?.shortLabel || 'Feedback'}`
    }
    else if(user?.permissions?.find(item => item.productCode ==4 )){
      product.productCode = 4;
      this.hideFeedbackAndComplaintsSubMenu(product,3,unchangedSideMenuProduct)
      return `${labelSetting?.Complaint?.shortLabel || 'Complaints'}`
    } 




  }

  hideFeedbackAndComplaintsSubMenu(product, productCode, unchangedSideMenuProduct){
     for(let menu of product.sublist){
            if(menu?.sublist?.length){
                let subMenu = menu.sublist?.find(item => item.productCode == productCode);
                if(subMenu){

                  subMenu.hidden = true;

                }
            }
      }
      for(let menu of unchangedSideMenuProduct?.sublist){
            if(menu?.sublist?.length){
                let subMenu = menu.sublist?.find(item => item.productCode == productCode);
                if(subMenu){

                  subMenu.hidden = true;

                }
            }
      }
    }

  showErrorMessage(object, errMsg, key = 'errorMsg'){

    if(!object){
      return;
    }

    object[key] = errMsg

    if(object['errorMsgTimoutId']){

      clearTimeout(object['errorMsgTimoutId']);

    }

    object['errorMsgTimoutId'] = setTimeout(() => {

      object[key] = null

    },5000)

  }

  getVisitUrlForLogs(visit){

    if(!visit?.slot?.startTime || !visit?.slot?.endTime || !(visit?.id || visit?._id)){
      return;
    }

    let dashboard = window.location.href?.includes('employee-dash') ? 'employee-dash': 'admin-dash'

    let page = 'checkin-logs'

    let isLongterm = moment(visit?.slot?.endTime).diff(moment(visit?.slot?.startTime),'days')>=1
    
    if(!visit?.preVisit ){
      page = 'checkin-logs'
    }

    if(visit?.preVisit && isLongterm){
      page = 'long-term-logs' 
    }
    if(visit?.preVisit && !isLongterm){
       page = 'prebooking-logs' 
    }

    if(visit){
      return window.location.origin+`/${dashboard}/${page}?from=${visit.slot?.startTime}&to=${visit.slot?.endTime}&visitIds=${visit?.id || visit?._id}&page=${1}&officeId=${visit?.officeId}`
    }
            

  }


  }

